<template>
  <table-layout>
    <template v-slot:title>
      <span>목록 (총 {{ data.length }}개)</span>
    </template>
    <template v-slot:button>
      <v-text-field
          v-model="search"
          label="검색"
          append-icon="mdi-magnify"
          single-line outlined hide-details dense
      />
    </template>
    <template v-slot:table>
      <v-data-table
        height="55vh"
        :headers="getHeader(headers)"
        :search="search"
        :items="data"
        :item-class="getRowClass"
        :items-per-page="-1"
        fixed-header
        @dblclick:row="showDetailPopup"
      >
        <template v-slot:item.loanBrokerNo="{ value }">
          <div>{{ setLoanBrokerNoFormat(value) }}</div>
        </template>
        <template v-slot:item.sumPaymentAmount="{ value }">
          <div class="text-right">{{ inputComma(value) }}</div>
        </template>
        <template v-slot:item.totalDeductionAmount="{ value }">
          <div class="text-right">{{ inputComma(value) }}</div>
        </template>
        <template v-slot:item.netPaymentAmount="{ value }">
          <div class="text-right">{{ inputComma(value) }}</div>
        </template>
      </v-data-table>
    </template>
    <template v-slot:popup>
      <v-overlay v-model="isShowDetail" :light="true" :dark="false">
        <div class="close-button-layout">
          <span class="close-button" @click="closePopup">x</span>
        </div>
        <payment-statement
          class="payment-statement"
          :row-data="rowData"
        />
      </v-overlay>
    </template>
  </table-layout>
</template>
<script>
import TableLayout from "@/common/layout/TableLayout.vue";
import {PAYMENT_MANAGE_TABLE} from "@/util/TableHeaders";
import TableMixin from "@/mixin/TableMixin";
import PaymentStatement from "@/pages/Payment/PaymentStatement.vue";

export default {
  name: "PaymentManageTable",
  components: {PaymentStatement, TableLayout},
  props: ["data", "loading", "baseYm"],
  mixins: [TableMixin],
  data() {
    return {
      headers: PAYMENT_MANAGE_TABLE,
      isShowDetail: false,
      rowData: {},
      search: ""
    }
  },
  methods: {
    getRowClass(item) {
      if (item.checkNm === "퇴사") {
        return "row-disabled";
      }
      return "";
    },
    showDetailPopup(event, rowData) {
      this.rowData = rowData.item;
      this.isShowDetail = true;
    },
    closePopup() {
      this.isShowDetail = false;
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .row-disabled {
  background-color: #ffebee !important;
  color: #d32f2f;
}
.close-button-layout {
  position: absolute;
  top:5px;
  right: 20px;
  .close-button {
    font-size: 30px;
    font-weight: 700;
  }
  .close-button:hover {
    cursor: pointer;
  }
}
.payment-statement {
  width: 100%;
  height: 95vh;
  overflow-y: auto;
  background-color: white;
}
</style>